import createSeriesMetadata from './createSeriesMetadata';

function createStudyMetadata(StudyInstanceUID) {
	return {
		StudyInstanceUID,
		StudyDescription: '',
		ModalitiesInStudy: [],
		isLoaded: false,
		series: [],
		PatientID: null,
		PatientName: null,
		StudyDate: null,
		AccessionNumber: null,
		NumInstances: null,
		PatientBirthDate: null,
		/**
		 * @param {object} instance
		 */
		addInstanceToSeries: function (instance) {
			this.addInstancesToSeries([instance]);
		},
		/**
		 * @param {object[]} instances
		 * @param {string} instances[].SeriesInstanceUID
		 * @param {string} instances[].StudyDescription
		 */
		addInstancesToSeries: function (instances) {
			const { SeriesInstanceUID } = instances[0];
			if (!this.StudyDescription) {
				this.StudyDescription = instances[0].StudyDescription;
			}
			let series = this.series.find((s) => s.SeriesInstanceUID === SeriesInstanceUID);

			if (!series) {
				series = createSeriesMetadata(SeriesInstanceUID, StudyInstanceUID);
				this.series.push(series);
			}

			series.addInstances(instances);
		},

		setSeriesMetadata: function (SeriesInstanceUID, seriesMetadata) {
			const existingSeriesIndex = this.series.findIndex((s) => s.SeriesInstanceUID === SeriesInstanceUID);

			if (existingSeriesIndex > -1) {
				const existingSeries = this.series[existingSeriesIndex];
				console.log(
					'createStudyMetadata:setSeriesMetadata - updating existing series',
					JSON.parse(JSON.stringify(existingSeries)),
					JSON.parse(JSON.stringify(seriesMetadata)),
				);
				const newSeriesMetadata = Object.assign({}, existingSeries, seriesMetadata);
				this.series[existingSeriesIndex] = newSeriesMetadata;
			} else {
				const series = createSeriesMetadata(SeriesInstanceUID, StudyInstanceUID);
				this.series.push(Object.assign(series, seriesMetadata));
			}
		},
	};
}

export default createStudyMetadata;
